/* eslint-disable react/jsx-props-no-spreading */
import { jsx, css } from '@emotion/react';
import { define, transform, ui, when } from '@owenscorning/pcb.alpha';

import Renderer, { Presets, availablePresets, defaultPreset } from '../../../../OC/PageBuilder/ContactUs';

// TODO - i'd rather the defaults go the other way, but baby steps...

export default define`Contact Us`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/ContactUs`,
  category: ui`Modules/Categories/Page/Customizable`,
  view: ({ value }) => <Renderer {...value} locale={typeof Board !== 'undefined' ? Board.build.language : 'en-US'} />,
  edit: ({ Subschema }) => (
    <Subschema>
      {{
        preset: [
          ui`Choices`.of([]),
      {
            contents: transform`~build/site`(site => availablePresets(site)),
            label: 'Preset',
            visible: transform`~build/site`(site => site === 'www.owenscorning.com'),
            default: transform`~build/site`(site => defaultPreset(site)),
          },
        ],
        custom: [
          ui`Form`.of({
        title: ui`Text`({
          label: 'Title',
          default:
            (typeof Board !== 'undefined' && Presets[Board.build.language]?.pink?.title) || Presets['en-US'].pink.title,
        }),
        text: ui`Text`({
          label: 'Text',
          default:
            (typeof Board !== 'undefined' && Presets[Board.build.language]?.pink?.text) || Presets['en-US'].pink.text,
        }),
        phoneLabel: ui`Text`({
          label: 'Phone Label',
          default:
            (typeof Board !== 'undefined' && Presets[Board.build.language]?.pink?.phoneLabel) ||
            Presets['en-US'].pink.phoneLabel,
        }),
        phoneReal: ui`Text`({
          label: 'Real Phone Number',
          default:
            (typeof Board !== 'undefined' && Presets[Board.build.language]?.pink?.phoneReal) ||
            Presets['en-US'].pink.phoneReal,
        }),
        email: ui`Text`({
          label: 'Email Address',
          default:
            (typeof Board !== 'undefined' && Presets[Board.build.language]?.pink?.email) || Presets['en-US'].pink.email,
        }),
        emailUsText: ui`Text`({
          label: '"Email Us" Label',
          default: 'Email Us',
        }),
        callUsText: ui`Text`({ label: '"Call Us" Label', default: 'Call Us' }),
        formText: ui`Text`({ label: '"Form" Label', default: 'Form' }),
        form: ui`Modules/Page/Form`,
          }),
      {
        label: 'Custom',
        visible: when`../preset`.is.equal.to('custom'),
      },
    ],
      }}
    </Subschema>
  ),
});
